import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import MediaPickerModal from "../components/MediaPickerModal";
import { useNavigate } from "react-router-dom";
import { createUser } from "../action/user";
import { roleList } from "../action/role";
import { fetchOrganizationList } from "../action/organizationaction";
import { fetchProjectList } from "../action/Projectsaction";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const CreateNewAccount = () => {
  const navigate = useNavigate();
  const [showMediaPicker, setShowMediaPicker] = useState(false);
  const [banner, setBanner] = useState("");
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [projects, setProjects] = useState([]);

  const fetchRoles = async () => {
    try {
      const res = await roleList(1, 100);
      if (res?.status) {
        setRoles(res.data.list);
      }
    } catch (error) {
      console.log("Error");
    }
  };
  const getOrganizations = async () => {
    const res = await fetchOrganizationList(1, 100);
    if (res?.status) {
      setOrganization(res.data.list);
    }
  };
  const fetchProjects = async () => {
    try {
      const res = await fetchProjectList(1, 100);
      if (res?.status) {
        setProjects(res.data.list);
      }
    } catch (error) {
      console.log("Error");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      role_id: "",
      organization_id: "",
      project_id: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),

      email: Yup.string()
        .required("Email is required")
        .matches(
          /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
          "Enter a valid email address"
        ),

      role_id: Yup.string().required("Role is required"),

      organization_id: Yup.string().required("Organization is required"),

      project_id: Yup.string().required("Project is required"),
    }),
    onSubmit: async (values) => {
      const res = await createUser(values);
      if (res?.status) {
        toast.success(res.message);
        navigate("/account");
      } else {
        toast.error(res.message);
      }
    },
  });

  useEffect(() => {
    getOrganizations();
    fetchRoles();
    fetchProjects();
  }, []);
  return (
    <>
      <PageHeader pageTitle="Create New User" is_deploy_enable={false}>
        <button className="btn-white me-3" onClick={() => navigate("/account")}>
          Discard
        </button>
        <button
          type="button"
          className="btn-black"
          onClick={formik.handleSubmit}
        >
          Create User
        </button>
      </PageHeader>

      <div className="page-container">
        <div className="row">
          <div className="col-lg-8">
            <form onSubmit={formik.handleSubmit}>
              <div className="theme-card p-4 mb-4">
                <div className="card-title pb-3">General Information</div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="frm-input"
                        placeholder="Enter name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="text-danger">{formik.errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="frm-input"
                        placeholder="Enter email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="frm-group">
                  <label className="frm-label d-flex align-items-center">
                    Role
                  </label>
                  <select
                    name="role_id"
                    className="frm-select"
                    value={formik.values.role_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.role_id && formik.errors.role_id && (
                    <div className="text-danger">{formik.errors.role_id}</div>
                  )}
                </div>
                <div className="frm-group">
                  <label className="frm-label d-flex align-items-center">
                    Organizations
                  </label>
                  <select
                    name="organization_id"
                    className="frm-select"
                    value={formik.values.organization_id}
                    onChange={formik.handleChange}
                  >
                    <option value="">Select Organization</option>
                    {organization.map((org) => (
                      <option key={org._id} value={org._id}>
                        {org.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.organization_id &&
                    formik.errors.organization_id && (
                      <div className="text-danger">
                        {formik.errors.organization_id}
                      </div>
                    )}
                </div>
                <div className="frm-group">
                  <label className="frm-label d-flex align-items-center">
                    Projects
                  </label>
                  <select
                    name="project_id"
                    className="frm-select"
                    value={formik.values.project_id}
                    onChange={formik.handleChange}
                  >
                    <option value="">Select Project</option>
                    {projects.map((proj) => (
                      <option key={proj._id} value={proj._id}>
                        {proj.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.project_id && formik.errors.project_id && (
                    <div className="text-danger">
                      {formik.errors.project_id}
                    </div>
                  )}
                </div>
                {/* <div className="frm-group">
                                <label className="frm-label d-flex align-items-center">Profile Picture</label>
                                <div
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShowMediaPicker(true)}
                                >
                                    {banner ? (
                                        <img
                                            src={banner}
                                            alt="preview"
                                            style={{
                                                minHeight: "100%",
                                                maxWidth: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                minHeight: "100%",
                                                maxWidth: "100%",
                                                background: "#f5f5f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            Upload Profile Picture
                                        </div>
                                    )}
                                </div>

                            </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <MediaPickerModal
                show={showMediaPicker}
                onClose={() => setShowMediaPicker(false)}
                onSelect={(mediaUrl) => {
                    setBanner(mediaUrl);
                    setShowMediaPicker(false);
                }}
            /> */}
    </>
  );
};

export default CreateNewAccount;
